module.exports = __webpack_public_path__ + "static/img/left8.9db17b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/left8.png
// module id = 6cOt
// module chunks = 1